import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import _debounce from 'lodash/debounce'
import SearchBox from 'frontcore/views/search/SearchBox.vue'
import useRemoteFiltersStore from 'frontcore/presentation/remote-filters/data/use-remote-filters-store'
import { computed } from 'vue'
import {
  RemoteFiltersFieldType,
  RemoteFiltersStoreConfiguration,
} from 'frontcore/presentation/remote-filters/domain/types'

type Props = {
  filterURL: string
  storeConfiguration?: RemoteFiltersStoreConfiguration
}
const SEARCH_DELAY_MS = 750


export default /*@__PURE__*/_defineComponent({
  __name: 'RemoteFiltersSearch',
  props: {
    filterURL: {},
    storeConfiguration: {}
  },
  setup(__props: any) {

const props = __props

const filtersStore = useRemoteFiltersStore(props.filterURL, props.storeConfiguration)

const hasSearchFilter = computed<boolean>(() => {
  return filtersStore.moduleRemoteFiltersConfigurations.some(filter => filter.filterType === RemoteFiltersFieldType.SEARCH)
})

const updateSearchText = _debounce((newSearchText?: string) => {
  filtersStore.searchText = newSearchText ?? ''
}, SEARCH_DELAY_MS)


return (_ctx: any,_cache: any) => {
  return (hasSearchFilter.value)
    ? (_openBlock(), _createBlock(SearchBox, {
        key: 0,
        value: _unref(filtersStore).searchText,
        "data-test": "core-filter-search-box",
        onInput: _unref(updateSearchText)
      }, null, 8, ["value", "onInput"]))
    : _createCommentVNode("", true)
}
}

})